import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionHeader } from './ui/SectionHeader';
import { faqs } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq" className="border-b border-arena bg-crudo" data-id="element-40" data-mp="1nwvwmzb64jqt">
      <div className="mx-auto max-w-2xl px-4 py-6 sm:py-9" data-id="element-41" data-mp="2bkvvkmimvggh">
        <SectionHeader id="faq" title="Preguntas frecuentes" data-id="element-42" data-mp="2fmh6w3firmok" />
        <div className="mt-3 space-y-1.5" data-id="element-43" data-mp="2fns8pxpemkd1">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={faq.q} className={`rounded-xl border bg-arena/30 transition-colors duration-150 ease-soft ${isOpen ? 'border-terracota/60' : 'border-arena'}`} data-id="element-44" data-mp="26slxukba1c3n" data-mpi={i}>
                <h3 data-id="element-45" data-mp="2zbrknbvpfxk1">
                  <button type="button" id={`faq-trigger-${i}`} onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-3 rounded-xl px-3 py-2.5 text-left" data-id="element-46" data-mp="1vpht7ww1rnrs">
                    <span className="text-sm font-bold text-marron" data-id="element-47" data-mp="2fdic0p0of6ku">{faq.q}</span>
                    <ChevronDownIcon size={16} aria-hidden="true" className={`flex-shrink-0 text-terracota transition-transform duration-200 ease-soft ${isOpen ? 'rotate-180' : ''}`} data-id="element-48" data-mp="2aenstlysrg07" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-49" data-mp="u0xk21wqg3k8">
                  {isOpen && <motion.div id={`faq-panel-${i}`} role="region" aria-labelledby={`faq-trigger-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: EASE
              }} className="overflow-hidden" data-id="element-50" data-mp="p2mc5wq0034n">
                      <p className="px-3 pb-2.5 text-[0.8rem] leading-snug text-marron/80 sm:text-sm" data-id="element-51" data-mp="3837ux4zxndin">{faq.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}